import type { FieldErrors } from "react-hook-form";

/**
 * Dot-separated paths of every invalid field, e.g. `delivery.postalCode`.
 * Only field names are collected — never the values the user typed.
 */
export function getInvalidFieldPaths(
  errors: FieldErrors | Record<string, unknown>,
  prefix = "",
): string[] {
  return Object.entries(errors).flatMap(([key, error]) => {
    if (!error || typeof error !== "object") return [];
    const path = prefix ? `${prefix}.${key}` : key;
    if ("message" in error || "type" in error) return [path];
    return getInvalidFieldPaths(error as Record<string, unknown>, path);
  });
}
